import React, { Component } from 'react';
import { Button, Card, Col, Form, Input, Row, Select } from 'antd';
import { BackBtn } from '@comm/BackBtn';
import UploadFile from '@comm/upload/UploadFile';

const { Option } = Select;
const FormItem = Form.Item;

const categoryName = ['文档', '链接'];

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      category: 0,
      files: [],
    };
  }

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {
    if (nextProps.dataInfo.url) {
      this.setState({
        files: [{ name: nextProps.dataInfo.title, url: nextProps.dataInfo.url }],
      });
    }
    if (this.props.dataInfo.category !== nextProps.dataInfo.category) {
      this.setState({
        category: nextProps.dataInfo.category,
      });
    }
  }

  submit = e => {
    if (e) {
      e.preventDefault();
    }
    const { handSubmit } = this.props;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        handSubmit(values);
      }
    });
  };

  handleCategoryChange = value => {
    this.setState({ category: value });
  };

  handleUpload = fileList => {
    let file = {};
    if (fileList && fileList.length > 0) {
      file = fileList[0];
      this.props.form.setFieldsValue({
        url: file.url,
      });
    }
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { dataInfo } = this.props;
    const { category, files } = this.state;
    const ItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 12 },
    };
    return (
      <Form onSubmit={this.submit}>
        <div style={{ marginBottom: '16px' }}>
          <BackBtn />
          <Button type="primary" style={{ marginRight: 10 }} htmlType="submit">
            确认
          </Button>
        </div>
        <Card>
          <Row>
            <Col span={10}>
              <FormItem label="标题" {...ItemLayout}>
                {getFieldDecorator(`title`, {
                  rules: [
                    {
                      required: true,
                      message: '填写标题',
                    },
                  ],
                  initialValue: dataInfo.title,
                })(<Input type="text" placeholder="标题" />)}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="类型" {...ItemLayout}>
                {getFieldDecorator('type', {
                  initialValue: dataInfo.type || 0,
                })(
                  <Select>
                    <Option value={0}>公司公告</Option>
                    <Option value={1}>业务动态</Option>
                  </Select>,
                )}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="类型" {...ItemLayout}>
                {getFieldDecorator('category', {
                  initialValue: dataInfo.category || 0,
                })(
                  <Select onChange={this.handleCategoryChange}>
                    <Option value={0}>文档</Option>
                    <Option value={1}>链接</Option>
                  </Select>,
                )}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label={`${categoryName[category]}`} {...ItemLayout}>
                {getFieldDecorator('url', {
                  rules: [
                    {
                      required: true,
                      message: `${categoryName[category]}不能为空`,
                    },
                  ],
                  initialValue: category === 1 ? dataInfo.url : files,
                })(
                  category === 1 ? (
                    <Input placeholder="链接" type="text" />
                  ) : (
                    <UploadFile handleUpload={this.handleUpload} fileList={files} limit={1} />
                  ),
                )}
              </FormItem>
            </Col>
          </Row>
        </Card>
      </Form>
    );
  }
}

export default Form.create()(BaseForm);



// WEBPACK FOOTER //
// ./src/components/administrative/announcement/FormBase.js